import styled, { Color, Spacing, Font, keyframes, css } from '@nfinite/react-hubstairs/styled'

import TooltipComponent from 'components/Commons/Tooltip/Lite'

import ButtonComponent from 'components/Commons/Button'

const SIZE_BUTTON = 40

const shakeIt = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`

export const Tooltip = styled(TooltipComponent)`
  & > .react-tooltip-lite {
    background-color: ${Color.get('gray', 'lighter')};
    color: ${Color.get('text')};
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.4);

    animation: ${({ shake, isOpen }) =>
      shake && isOpen
        ? css`
            ${shakeIt} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both
          `
        : ''};
  }

  & > .react-tooltip-lite-arrow {
    border-color: ${Color.get('gray', 'lighter')};

    animation: ${({ shake, isOpen }) =>
      shake && isOpen
        ? css`
            ${shakeIt} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both
          `
        : ''};
  }
`

export const Overlay = styled('div')`
  position: fixed;
  z-index: 9991;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`

export const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${Spacing.generatePadding({ all: 'xs' })}
  max-width: 600px;
`

export const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: row;
`

export const Confirmation = styled('p')`
  ${Spacing.generateMargin({ left: 'xxs', right: 'l' })}
  ${Font.generate({ weight: 'bold' })}
  white-space: pre-line;
`

export const Button = styled(ButtonComponent)`
  min-width: unset;
  width: ${SIZE_BUTTON}px;
  height: ${SIZE_BUTTON}px;
  ${Spacing.generateMargin({ left: 'xxs', right: 'xxs' })}
`
